import { Box, ToggleButton, Tooltip } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import {
    useAppSidePanelContextProvider
} from "../../../shared/contexts/app-side-panel-context-provider/components/AppSidePanelContextProvider";
import BalanceIcon from '@mui/icons-material/Balance';

export function DeltaNeutralPriceSwitcher() {
    const {
        selectedPortfolio,
        updateSelectedPortfolio,
        saveSelectedPortfolio,
    } = useAppSidePanelContextProvider();

    const initialValue = selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null
        ? selectedPortfolio.portfolioSettings.showDeltaNeutralPriceLines
        : false;
    
    const [showDeltaNeutralPriceLines, setShowDeltaNeutralPriceLines] = useState<boolean>(initialValue);

    useEffect(() => {
        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null)
            setShowDeltaNeutralPriceLines(selectedPortfolio.portfolioSettings.showDeltaNeutralPriceLines);
    }, [selectedPortfolio]);
    
    const onChange = async () => {
        const newValue = !showDeltaNeutralPriceLines;

        setShowDeltaNeutralPriceLines(newValue);
        
        if (selectedPortfolio !== null && selectedPortfolio.portfolioSettings !== null) {
            selectedPortfolio.portfolioSettings.showDeltaNeutralPriceLines = newValue;
            updateSelectedPortfolio();
            saveSelectedPortfolio();
        }
    }
    
    return (
        <Tooltip
            placement="bottom-start"
            disableInteractive
            arrow
            componentsProps={{
                tooltip: {
                    sx: {
                        maxWidth: '500px'
                    },
                },
            }}
            slotProps={{
                popper: {
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 2],
                            },
                        },
                    ],
                },
            }}
            title={
                <Fragment>
                    <Box sx={{fontSize: "13px"}}>
                        {
                            showDeltaNeutralPriceLines
                                ? "Hide a delta-neutral price lines for portfolios"
                                : "Show a delta-neutral price lines for portfolios"
                        }
                    </Box>
                </Fragment>
            }
        >
            <ToggleButton
                value="check"
                selected={showDeltaNeutralPriceLines}
                color="standard"
                onChange={onChange}
                sx={{
                    borderColor: "#9e9d9d",
                    marginTop: '10px',
                    marginLeft: '-20px',
                    height: '5px',
                    width: '5px',
                    '&.Mui-selected': {
                        backgroundColor: '#cdcdcd',
                    },
                }}
            >
                <BalanceIcon sx={{
                    height: '18px',
                    width: '18px',
                }} />
            </ToggleButton>
        </Tooltip>
    );
}